module.exports = __webpack_public_path__ + "img/steps-create.d9392159.svg";